import MoreVertIcon from '@mui/icons-material/MoreVert';
import edifiedBtn from "./otherImg/newedified.png";
import edifiedred from "./otherImg/newedifiedred.png";
import { Cancel } from '@mui/icons-material';
import { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { Timestamp, arrayRemove, arrayUnion, collection, deleteDoc, doc, onSnapshot, orderBy, query, setDoc, updateDoc, where } from 'firebase/firestore';
import db, { realTimeDB, storage } from './firebase';
import { format } from 'date-fns';
import { AuthContext } from './AuthContext';
import CommentContent from './blogcomments/CommentContent';
import EdifiedContentList from './blogcomments/EdifiedContentList';
import { useLocation, useNavigate } from 'react-router-dom';
import { addBlogsToDB, deleteEdifiedData, getEdifiedStateDB, initDB, trackEdifiedStateDB } from './ConfigureIndexDB';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import BlogTextShortener from './Textshortener2';
import { deleteObject, ref as storageRef } from 'firebase/storage';
import { actionConsts, reducer } from './newComponents/StateManager';
import { HbrAvatarProfile, HbrBrushIcon, HbrCancel,HbrForwardIcon, HbrPlayButton, HbrSendIcon} from './newComponents/Mycustomsvgicons';
import UseLayout from "./newComponents/useLayout";
import { DisplayUserPicAndName, FormatTimePassedUtc, handleDecreaseEdifiedCount, handleRealtimeDataChanges, removePostAnalytics, sanitizeText, shareBlogPost, ShortenText } from './newComponents/GeneralClasses';
import { off, onValue, ref} from 'firebase/database';
import CustomTextArea from './newComponents2/CustomTextArea';
import { ConstVariables } from './newComponents2/ConstantVariables';
import AddToNotificationDB from './newComponents2/AddToNotificationDB';


const BlogContent = ({postID,blog_message,images,timestamp,blogger_email,blogger_name,edifiedby,videolink,video_thumb}) => {
    const [showMenuItems,setShowMenuItems]=useState(false);
    const [postComment,setPostComment]=useState(false);
    const [commentText,setCommentText]=useState("");
    const [commentLists,setCommentlists]=useState([]);
    const [commentsDIsplay,setCommentDisplay]=useState(false);
    const [edifiedLists,setEdifiedLists] = useState([]);
    const [displayEdifiedList,setDisplayedifiedlist]=useState(false);
    const [displayEdifiedList2,setDisplayedifiedlist2]=useState(false);
    const [isSaved,setSaved]=useState(false); 
    const [showNotFoundalert,setShowAlert]=useState(false);
    const edifiedRef = useRef(null);
    const today = new Date();
    const commentID = format(today,"yyyyMMddHHmmss");
    const now = Timestamp.now();
    const utcTime = new Date(now?.toDate()).toUTCString();
    const timestamp2 = new Date().getTime();
    const {profile_pic} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const {user_email} = useContext(AuthContext);
    const {verifiedUid} = useContext(AuthContext);
    const [imageData,setImageData]=useState({image:"",i:0});
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, views: 0, shares: 0, commentCounut: 0, edifiedCount: 0, regularUserEdified: false, userProfile: null, userNameToDisplay: "", userProfilePic: "", notificationText: ""});
    const {width} = UseLayout();
    const navigate = useNavigate();
    const location = useLocation();


    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(blogger_email);
            if (userInfo) {
                const nameFromDB = userInfo.name && userInfo.name !== "" ? userInfo.name : blogger_name;
                dispatch({type: actionConsts.USER_NAME_DISPLAY, payload: nameFromDB});
                dispatch({type: actionConsts.USER_PICTURE, payload: userInfo.profilePic});
            };
        }
        getUserInfo();
    },[blogger_email, blogger_name]);

    const getMediaStoragePath=(url)=>{
    const regex = /o\/(.*?)\?/;
    const match = url.match(regex);
        const lastpath =match ? match[1] : null;
        return lastpath.replace(/%2F/g,"/");
    };

    const deleteBlogDoc=async()=>{
        if(blogger_email === user_email){
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
            try{
                if(videolink && videolink !== ""){
                    const videoPath = storageRef(storage,`${getMediaStoragePath(videolink)}`);
                    await deleteObject(videoPath);
                    if(video_thumb && video_thumb !== ""){
                        const videoThumbPath = storageRef(storage,`${getMediaStoragePath(video_thumb)}`);
                        await deleteObject(videoThumbPath);
                    }
                }

                if(images && images.length > 0){
                    for( let i=0; i < images.length; i++){
                        const imagePath = storageRef(storage,`${getMediaStoragePath(images[i])}`);
                        await deleteObject(imagePath);
                    }
                }

            const doc_Ref = doc(db,"Blog Posts",postID);
            await deleteDoc(doc_Ref);
            removePostAnalytics(postID);
            dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});

            }catch(error){
                dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
            }
        }
    };

    const sendComment=async()=>{
        if(verifiedUid){
            try{
                if(commentText !== ""){
                    setCommentText("");
                    await setDoc(doc(db,ConstVariables.BLOG_COMMENTS_PATH,commentID),{
                        post_commentID: commentID,
                        post_comment_name: userName,
                        post_comment_email: user_email,
                        commenterProfilePic: "",
                        post_comment_date: utcTime,
                        post_comment_text: commentText,
                        blogOnFocus: postID,
                        timestamp: timestamp2
                    });
                handleRealtimeDataChanges(ConstVariables.COMMENT_COUNT, postID);
                AddToNotificationDB(
                    ConstVariables.BLOG_COMMENTS,
                    `${userName} commented on ${blogger_name}'s post: ${ShortenText(commentText, 50)}`,
                    ConstVariables.DUMMI_IMAGE,
                    postID,
                    "",
                    ConstVariables.DIVINE_BLOGS_TOPIC,
                    user_email
                  );
                }
            }catch{
            }
        }else{
            setShowAlert(true);
        }
    };

    useEffect(()=>{
        const collectionRef = collection(db,"edified souls");
        const q = query(collectionRef,where("post_doc_id","==",postID),orderBy("timestamp","desc"));
        try{
            const unsub = onSnapshot(q, (snapshot)=>{
                const edifiedDocs = [];
                snapshot.forEach((doc)=>{
                    edifiedDocs.push(doc.data());
                });
                setEdifiedLists(edifiedDocs);
            });
            return unsub;
        }catch(error){
            console.log(error);
        }
    },[postID]);

    const trackEdifiedState =async()=>{
        if(verifiedUid){
            try{
                const docID = `${sanitizeText(user_email)}${postID}`;
                await updateDoc(doc(db,"Blog Posts",postID),{
                    edifiedby: arrayUnion(user_email)
                });

                await setDoc(doc(db,"edified souls", docID),{
                    edifiedID: docID,
                    name: userName,
                    display_picture: "",
                    date_reacted: utcTime,
                    post_doc_id: postID,
                    timestamp
                });
                handleRealtimeDataChanges(ConstVariables.EDIFIED_COUNT,postID);
                dispatch({type: actionConsts.NOTIFICATIONTEXT, payload: `${userName} was edified by ${blogger_name}'s post ❤❤.`});
                AddToNotificationDB(
                    ConstVariables.DIVINE_BLOGS_TITLE,
                    state.notificationText,
                    ConstVariables.DUMMI_IMAGE,
                    postID,
                    "",
                    ConstVariables.DIVINE_BLOGS_TOPIC,
                    user_email
                  );
            }catch{
            }
        }else{
            handleRealtimeDataChanges(ConstVariables.EDIFIED_COUNT,postID);
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: true});
                await initDB();
                await trackEdifiedStateDB({
                    id: timestamp,
                    shID: postID
                });
                dispatch({type: actionConsts.NOTIFICATIONTEXT, payload: `A user was edified by ${blogger_name}'s post ❤❤`});
                AddToNotificationDB(
                    ConstVariables.DIVINE_BLOGS_TITLE,
                    state.notificationText,
                    ConstVariables.DUMMI_IMAGE,
                    postID,
                    "",
                    ConstVariables.DIVINE_BLOGS_TOPIC,
                    user_email
                  );
        }
       
    };

    const removeEdified = async()=>{
            if (verifiedUid) {
                try{
                    const docID = `${sanitizeText(user_email)}${postID}`;
                    await updateDoc(doc(db,"Blog Posts",postID),{
                        edifiedby: arrayRemove(user_email)
                    });
                    const doc_Ref = doc(db,"edified souls", docID);
                    await deleteDoc(doc_Ref);
                    handleDecreaseEdifiedCount(postID);
                }catch{
                }
            }else{
                handleDecreaseEdifiedCount(postID);
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: false});
                await initDB();
                await deleteEdifiedData(timestamp);
            }
    };

    useEffect(()=>{
        async function getEdifiedStateOfRegularUser() {
            await initDB();
            const res = await getEdifiedStateDB(timestamp);
            if (res) {
                res.shID === postID ? 
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: true})
                :
                dispatch({type: actionConsts.REGULAR_USER_EDIFIED, payload: false});
            }
        }
        getEdifiedStateOfRegularUser();
    },[postID, timestamp]);

    useEffect(()=>{
        const collectionRef = collection(db,"blog comments");
        const q = query(collectionRef,where("blogOnFocus","==",postID),orderBy("timestamp","asc"));
        try{
            const unsub = onSnapshot(q, (snapshot)=>{
                const commentsDocs = [];
                snapshot.forEach((doc)=>{
                    commentsDocs.push(doc.data());
                });
                setCommentlists(commentsDocs);
            });
            return unsub;
        }catch(error){
            console.log(error);
        }
    },[postID]);

    useEffect(()=>{
        const postViewsRef = ref(realTimeDB, `Reactions/${postID}/views`);
        const sharesRef = ref(realTimeDB, `Reactions/${postID}/shares`);
        const commentsRef = ref(realTimeDB, `Reactions/${postID}/comments`);
        const edifiedRef = ref(realTimeDB, `Reactions/${postID}/edified`);

        const viewsListener = onValue(postViewsRef, (snapshot)=>{
            if (snapshot.exists()) {
                dispatch({type:actionConsts.VIEWS, payload: snapshot.val()})
            }
        })
        const sharesListener = onValue(sharesRef, (snapshot)=>{
            if (snapshot.exists()) {
                dispatch({type:actionConsts.SHARES, payload: snapshot.val()})
            }
        })
        const commentsListener = onValue(commentsRef, (snapshot)=>{
            if (snapshot.exists()) {
                dispatch({type:actionConsts.COMMENT_COUNT, payload: snapshot.val()})
            }
        })
        const edifiedListener = onValue(edifiedRef, (snapshot)=>{
            if (snapshot.exists()) {
                dispatch({type:actionConsts.EDIFIED_COUNT, payload: snapshot.val()})
            }
        })

        return()=>{
            off(postViewsRef,viewsListener);
            off(sharesRef,sharesListener);
            off(commentsRef,commentsListener);
            off(edifiedRef,edifiedListener);
        }

    },[postID]);

    const savePost =()=>{
        initDB().then(()=>{
            addBlogsToDB({
                id: postID,
                blogId: postID
            }).then((res)=>{
                if(res === true){
                    setSaved(true);
                }
            }).catch((error)=>{
                console.log(error);
            });
        }).catch((error)=>{
            console.log(error);
        });
    };
    
    useEffect(()=>{
        if (displayEdifiedList || displayEdifiedList2) {
            const closeedifiedlist=(e)=>{
                try {
                    if (edifiedRef) {
                        if(!edifiedRef.current.contains(e.target)){
                            setDisplayedifiedlist(false);
                            setDisplayedifiedlist2(false);
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
             
            }
        
            document.addEventListener('mousedown',closeedifiedlist);
            return () => {
            document.removeEventListener('mousedown',closeedifiedlist);
            }   
        }
    },[displayEdifiedList, displayEdifiedList2]);

    const viewImage=(image,i)=>{
        setImageData({image,i});
    };
    const closeViewImage=()=>{
        setImageData({image:"",i:0});
    };
    const handleImageChange=(actionType)=>{
        let index = imageData.i;

        if(actionType === "next"){
            let lastImage = index === images.length -1;
            const nextImage = lastImage ? 0 : index + 1;
            setImageData({image:images[nextImage],i:nextImage});
        }
        if(actionType === "prev"){
            let firstImage = index === 0;
            const prevImage = firstImage ? images.length-1 : index-1;
            setImageData({image:images[prevImage],i:prevImage});
        }
    };

    const goToprofilePage=()=>{
        navigate(`/profilepage?hbruserref=${sanitizeText(blogger_email)}&socialhandle=${state.userNameToDisplay}`, 
        {state: {from: location.pathname}})
    }
   



 

    return ( 
        <div className="blogposts">
                 
            {imageData.image &&
                <div className='imageViewPane'>
                        {images && images.length > 1 && 
                            <button className="imagechangebtn" onClick={()=>handleImageChange("prev")}>
                                <ArrowBackIos/>
                            </button>
                        }

                        <div style={{position:"absolute",top:"2em",right:"2em"}}>
                            <HbrCancel width="2em" height="2em" fillColour="#ffffff" handleClick={()=>closeViewImage()}/>
                        </div>
                
                        <img src={imageData.image} alt='' style={{width:"auto",maxWidth:"95%",maxHeight:"95%"}} />

                        {images && images.length > 1 && 
                            <button className="imagechangebtn" onClick={()=>handleImageChange("next")}>
                                <ArrowForwardIos/>
                            </button>
                        }

                        {width <= 1024 && 
                            <div className='flex-spacebetween' style={{
                                position: 'absolute',
                                top: '50%',
                                width: "90%" 
                            }}>
                            <button className="imagechangebtn-phone" onClick={()=>handleImageChange("prev")}>
                                <ArrowBackIos/>
                            </button>

                            <button className="imagechangebtn-phone" onClick={()=>handleImageChange("next")}>
                                <ArrowForwardIos/>
                            </button>

                            </div>
                        }
                        
                </div>
            }

            <div className="blogPosthead">
                {/* <Link  to={`/profilepage?hbruserref=${sanitizeText(blogger_email)}&socialhandle=${state.userNameToDisplay}`} className="bloggerinfolink"> */}
                    <div className="bloggerinfo" onClick={()=>goToprofilePage()}>
                        {
                           state.userProfilePic !=="" ?
                            (<img id="blogProfile" src={state.userProfilePic} alt="" />)
                            :
                            (<HbrAvatarProfile width={"2em"} height={"2em"}/>)
                        }

                        <div style={{
                            display:"flex",
                            flexDirection:"column",
                            alignItems:"center",
                            justifyContent:"center"
                            }}>
                            <h4>{state.userNameToDisplay}</h4>
                            {timestamp && <p>{FormatTimePassedUtc(timestamp)}</p>}
                        </div>
                    </div>
                

                <div className="menuitemdiv">
                    {!showMenuItems && 
                    <div style={{cursor:"pointer"}}
                        onClick={setShowMenuItems}>
                        <MoreVertIcon/>
                    </div>
                    }

                    {showMenuItems && 
                        <div className="blogpostmenu">
                            <HbrCancel width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>setShowMenuItems(false)}/>

                            {blogger_email === user_email &&
                                (
                                <button onClick={()=>deleteBlogDoc(postID,blogger_email)}>
                                    Delete
                                </button>
                                ) 
                            }
                            <button onClick={()=>goToprofilePage()}> 
                                View Profile
                            </button>
                            <button onClick={()=>savePost()}>Save</button>
                            <button onClick={()=>navigate("/contact", {state: {from: location.pathname}})}>Report</button>
                            <button onClick={()=>setDisplayedifiedlist2(prev => !prev)}>Edified by</button>
                   
                            
                            {displayEdifiedList2 &&
                                <div className="edifieddisplayarea2" ref={edifiedRef}>
                                          <p>List exlude users who prefer to hide their interactive details on a post</p>
                                    {edifiedLists && edifiedLists.map((data,index)=>(
                                        <EdifiedContentList 
                                            key={index}
                                            personname={data.name}
                                            date_reacted = {data.date_reacted}
                                            display_picture = {data.display_picture}
                                            timestamp = {data.timestamp}
                                        />
                                    ))}
                                </div>
                            }
                        
                            {postComment && <button onClick={()=>setPostComment(false)}>Close comment</button>}
                        </div>
                    }
                    </div>
            </div>


            <div className="blogPostText" style={{width:"100%"}}>
                {blog_message && <BlogTextShortener fullText={blog_message} words={100}/>}
            </div>
                
            {images && images.length > 2 ?
                <ResponsiveMasonry
                style={{width:"100%"}}
                columnsCountBreakPoints={{350:1, 750:2, 900:3}}
                >
                    <Masonry gutter='20px'>
                    {images.map( (image,index)=>(
                    <img key={index} 
                    src={image} alt='' 
                    style={{width:"100%",display:"block",cursor:"pointer"}}
                    onClick={()=>viewImage(image,index)}/>
                    ))}
                    </Masonry>
                </ResponsiveMasonry>

                :
                <div className="doubleorsingleimg">
                    {images && images.map( (image,index)=>(
                    <img key={index} 
                    src={image} alt='' 
                    onClick={()=>viewImage(image,index)}/>
                    ))}
                </div>
            
            }

            {state.progressIndicator && 
                <div style={{
                    position:"absolute",
                    top:"50%",
                    left:"45%",
                    border: "5px solid black",
                    borderBottom: "5px solid white",
                    borderTop: "5px solid white",
                    borderRadius: "50%",
                    animation: "spin2 2s linear infinite",
                    backgroundColor: "#00000050"
                    }}>
                        <HbrBrushIcon width="2em" height="2em" fillColour="#ffffff"/>
                </div>
            }
         
            
            {videolink && 
                <div className="blogpostvideo">
                        {video_thumb && <img src={video_thumb} alt='video thumnbnail' style={{width:"100%",height:"100%",objectFit:"cover"}}/>} 

                        <div>
                        <HbrPlayButton width="2.5em" height="2.5em" fillColour="#ffffff" handleClick={()=> navigate(`/divineblogsvideo/${postID}`,{state: {from: location.pathname}})} />
                        </div>
                </div>
            }

            <div className="blogpostreactions">
                    <div className='blogcommenttrigger'>
                            <button style={{
                                border:"none",
                                backgroundColor:"transparent",
                                cursor:"pointer",
                                fontWeight:"bold"
                            }}
                            onClick={()=>setPostComment(prev => !prev)}
                            >Comment
                            </button>
                        
                        
                        <p onClick={()=>setCommentDisplay(prev => !prev)} style={{fontWeight:"bold", cursor:"pointer"}}>
                            {state.commentCounut > 0 &&
                             (state.commentCounut === 1 ?
                                `${state.commentCounut} comment` 
                                : 
                                `${state.commentCounut} comments`
                            )}
                        </p>
                    </div>

                    {videolink && 
                        <div className='flex-column2'>
                          <p style={{visibility:"hidden"}}>Views</p>
                          <p style={{fontWeight:"bold"}}>
                                {state.views > 0 &&
                                    (state.views === 1 ?
                                    `${state.views} view` 
                                    : 
                                    `${state.views} views`
                                )}
                          </p>
                      </div>
                    }

                    <div className='edifiedtrigger' style={{position:"relative"}} >
                        {verifiedUid && 
                        <div>
                            {edifiedby && edifiedby.includes(user_email) ? 
                            (
                                <img src={edifiedred} alt='edified button' onClick={() => removeEdified()}/>
                            )
                            :
                            (
                                <img src={edifiedBtn} alt="edified button" onClick={()=>trackEdifiedState()}/> 
                            ) 
                            }
                        </div>
                        
                        }

                        {!verifiedUid &&
                            <div>
                                {
                                    state.regularUserEdified ?
                                    (
                                        <img src={edifiedred} alt='edified button' onClick={() => removeEdified()}/>
                                    )
                                    :
                                    (
                                        <img src={edifiedBtn} alt="edified button" onClick={()=>trackEdifiedState()}/> 
                                    )
                                }
                            </div>
                        }

                        <p style={{fontWeight:"bold",cursor:"pointer"}} onClick={()=>setDisplayedifiedlist(prev => !prev)}>
                                {state.edifiedCount > 0 &&
                                    (`${state.edifiedCount} edified`)
                                }
                        </p>

                        {displayEdifiedList &&
                            <div className="edifieddisplayarea" ref={edifiedRef}>
                                <p>List exlude users who prefer to hide their interactive details on a post</p>
                                {edifiedLists && edifiedLists.map((data, index)=>(
                                    <EdifiedContentList 
                                        key={index}
                                        personname={data.name}
                                        date_reacted = {data.date_reacted}
                                        display_picture = {data.display_picture}
                                        timestamp = {data.timestamp}
                                    />
                                ))}
                            </div>
                        }
                    </div>

                    <div className='flex-column2'>
                         <HbrForwardIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>shareBlogPost(blogger_name,postID)}/>
                         <p style={{fontWeight:"bold"}}>
                                {state.shares > 0 &&
                                    (state.shares === 1 ?
                                        `${state.shares} share` 
                                        : 
                                        `${state.shares} shares`
                                    )
                                }
                         </p>
                    </div>
                 
            </div>

            <div className="flex-row2" style={{gap:"5px"}}>
                {verifiedUid &&
                    (
                    <button style={{
                        border:"none",
                        backgroundColor:"transparent",
                        cursor:"pointer",
                        fontSize:"1em",
                        fontWeight:"bold"
                        }}
                        onClick={()=>setPostComment(prev => !prev)}>
                            {userName ? `Comment as ${userName}` : 'User not found'}
                    </button>
                    )
                }

                {profile_pic !== "" && 
                <img src={profile_pic} alt='' style={{width:"1.7em",height:"1.7em",objectFit:"cover",borderRadius:"50%"}} />
                }
            </div>
   

            {postComment && 
                <div className="writecommentarea">
                        {
                        profile_pic && profile_pic !== "" ? <img id="blogProfile" src={profile_pic} alt="" />
                        :
                        (<HbrAvatarProfile width={"2em"} height={"2em"}/>)
                        }
                        {verifiedUid ? 
                            <div className="textandsend">
                                   <CustomTextArea 
                                value={commentText} 
                                onChange={e => setCommentText(e.target.value)} 
                                hint={`comment as ${userName}`}
                                textareaLineHeight={24}
                                maxRows={6}
                                />
                                <HbrSendIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>sendComment()}/>
                            </div> 
                            :
                            <div className="textandsend">
                            <textarea placeholder="Comment disabled. User not found. Read more in the Help pane." disabled/>
            
                            </div> 
                        }
                   
                </div>
            }
          
            {commentsDIsplay && 
                <div className="commentdisplayarea">
                            {commentLists && commentLists.map((data)=>(
                            <CommentContent
                                key={data.timestamp}
                                username = {data.post_comment_name}
                                useremail = {data.post_comment_email}
                                profilepic = {data.commenterProfilePic}
                                postID  =   {postID}
                                commenttext = {data.post_comment_text}
                                commentID = {data.post_commentID}
                                timestamp = {data.timestamp}
                            />
                        ))}
                </div>
            }

            
            {
                isSaved &&
                <div className="toast">
                    <span style={{color:"white",fontWeight:"bold"}}>Post saved successfully</span> 
                    <button onClick={()=>setSaved(false)}><Cancel/></button>
                </div>
            }

            {showNotFoundalert && 
                  <div className="toast2">
                  <p style={{color:"white",fontWeight:"bold"}}>
                    Action revoked, user not found This alert often shows if the user is blocked.
                    contact support team for help.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setShowAlert(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
            }
        </div>
     )
}
export default BlogContent;